import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * Date input with prev/next arrow buttons for quick navigation
 * Usage: <DateNavInput value={date} onChange={setDate} />
 */
export function DateNavInput({ value, onChange, className = '' }) {
  const move = (delta) => {
    // Parse as UTC to avoid timezone-offset day shift bugs
    const [y, m, d] = value.split('-').map(Number);
    const date = new Date(Date.UTC(y, m - 1, d));
    date.setUTCDate(date.getUTCDate() + delta);
    onChange(date.toISOString().split('T')[0]);
  };

  return (
    <div
      className={`flex items-center gap-0 overflow-hidden rounded-2xl border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-900 ${className}`}
    >
      <button
        type="button"
        onClick={() => move(-1)}
        className="h-9 border-r border-slate-200 px-2.5 text-slate-500 transition-colors hover:bg-slate-50 hover:text-slate-800 dark:border-slate-700 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-200"
        title="Previous day"
        data-testid="date-prev-btn"
      >
        <ChevronLeft className="h-3.5 w-3.5" />
      </button>
      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-9 w-36 cursor-pointer border-0 bg-transparent px-2 text-sm text-slate-800 outline-none dark:text-slate-100 dark:[color-scheme:dark]"
        data-testid="date-input"
      />
      <button
        type="button"
        onClick={() => move(1)}
        className="h-9 border-l border-slate-200 px-2.5 text-slate-500 transition-colors hover:bg-slate-50 hover:text-slate-800 dark:border-slate-700 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-200"
        title="Next day"
        data-testid="date-next-btn"
      >
        <ChevronRight className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
